module.exports = require('./divide')
